<template>
  <div class="questionnaire" v-if="showModal && step == 2">
    <div class="modal-box" v-if="isMobile">
      <div class="modal-box-header">
        <img :src="moduleData.img_url" class="modal-box-image" />
        <div class="tips">为了更好地服务您，请您填写以下问题</div>
      </div>
      <div class="questions">
        <div class="question">
          <div class="question-name">
            <!-- <img src="../../assets/images/num-1.png" alt="" class="question-num"> -->
            <i>1.</i>
            <span>您需要了解的产品或服务？（多选）</span>
            <span v-if="notice1" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt1"
                :value="1"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt1">公募基金</label>
            </div>
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt2"
                :value="2"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt2">私募基金</label>
            </div>
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt3"
                :value="3"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt3">保险配置</label>
            </div>
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt4"
                :value="4"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt4">其他</label>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="question-name">
            <i>2.</i>
            <span>您的可投金额？</span>
            <span v-if="notice2" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt1"
                :value="1"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt1">20万以下</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt2"
                :value="2"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt2">20万-50万</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt3"
                :value="3"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt3">50万-100万</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt4"
                :value="4"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt4">100万以上</label>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="question-name">
            <i>3.</i>
            <span>您的年龄范围？</span>
            <span v-if="notice3" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt1"
                :value="1"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt1">29岁及以下</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt2"
                :value="2"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt2">30-39岁</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt3"
                :value="3"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt3">40-49岁</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt4"
                :value="4"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt4">50岁及以上</label>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="question-name">
            <i>4.</i>
            <span>您的常住地？</span>
            <span v-if="notice4" class="notice">请选择</span>
          </div>
          <div class="question-selector">
            <div class="question-select-wrapper">
              <select class="question-select" v-model="province">
                <option :value="{}" disabled>省</option>
                <option v-for="item in pro" :value="item">{{
                  item.name
                }}</option>
              </select>
            </div>
            <div class="question-select-wrapper">
              <select class="question-select" v-model="city">
                <option value="" disabled>市</option>
                <option v-for="item in province.ITEMS" :value="item.name">{{
                  item.name
                }}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <div class="question">
          <div class="question-name">
            <i>5.</i>
            <span>您是否需要专业的理财师服务？</span>
            <span v-if="notice5" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="radio"
                id="ques5opt1"
                :value="1"
                v-model="service"
                class="option-radio"
              />
              <label for="ques5opt1">需要</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques5opt2"
                :value="0"
                v-model="service"
                class="option-radio"
              />
              <label for="ques5opt2">不需要</label>
            </div>
          </div>
        </div> -->
      </div>
      <div class="modal-box-footer">
        <div class="modal-box-submit" @click="submit">提交</div>
      </div>
      <img
        src="../../assets/images/close.png"
        class="close"
        @click="closeModal"
      />
    </div>
    <div class="modal-box" v-else>
      <div class="modal-box-header">
        <img :src="moduleData.img_url" class="modal-box-image" />
        <div class="tips">为了更好地服务您，请您填写以下问题</div>
      </div>
      <div class="questions">
        <div class="question">
          <div class="question-name">
            <i>1.</i>
            <span>您需要了解的产品或服务？（多选）</span>
            <span v-if="notice1" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt1"
                :value="1"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt1">公募基金</label>
            </div>
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt2"
                :value="2"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt2">私募基金</label>
            </div>
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt3"
                :value="3"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt3">保险配置</label>
            </div>
            <div class="question-option">
              <input
                type="checkbox"
                id="ques1opt4"
                :value="4"
                v-model="products"
                class="option-checkbox"
              />
              <label for="ques1opt4">其他</label>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="question-name">
            <i>2.</i>
            <span>您的可投金额？</span>
            <span v-if="notice2" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt1"
                :value="1"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt1">20万以下</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt2"
                :value="2"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt2">20万-50万</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt3"
                :value="3"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt3">50万-100万</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques2opt4"
                :value="4"
                v-model="money"
                class="option-radio"
              />
              <label for="ques2opt4">100万以上</label>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="question-name">
            <i>3.</i>
            <span>您的年龄范围？</span>
            <span v-if="notice3" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt1"
                :value="1"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt1">29岁及以下</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt2"
                :value="2"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt2">30-39岁</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt3"
                :value="3"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt3">40-49岁</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques3opt4"
                :value="4"
                v-model="age"
                class="option-radio"
              />
              <label for="ques3opt4">50岁及以上</label>
            </div>
          </div>
        </div>
        <div class="question">
          <div class="question-name">
            <i>4.</i>
            <span>您的常住地？</span>
            <span v-if="notice4" class="notice">请选择</span>
          </div>
          <div class="question-selector">
            <div class="question-select-wrapper">
              <select class="question-select" v-model="province">
                <option :value="{}" disabled>省</option>
                <option v-for="item in pro" :value="item">{{
                  item.name
                }}</option>
              </select>
            </div>
            <div class="question-select-wrapper">
              <select class="question-select" v-model="city">
                <option value="" disabled>市</option>
                <option v-for="item in province.ITEMS" :value="item.name">{{
                  item.name
                }}</option>
              </select>
            </div>
          </div>
        </div>
        <!-- <div class="question">
          <div class="question-name">
            <i>5.</i>
            <span>您是否需要专业的理财师服务？</span>
            <span v-if="notice5" class="notice">请选择</span>
          </div>
          <div class="question-options">
            <div class="question-option">
              <input
                type="radio"
                id="ques5opt1"
                :value="1"
                v-model="service"
                class="option-radio"
              />
              <label for="ques5opt1">需要</label>
            </div>
            <div class="question-option">
              <input
                type="radio"
                id="ques5opt2"
                :value="0"
                v-model="service"
                class="option-radio"
              />
              <label for="ques5opt2">不需要</label>
            </div>
          </div>
        </div> -->
      </div>
      <div class="modal-box-footer">
        <div class="modal-box-submit" @click="submit">提交</div>
      </div>
      <img
        src="../../assets/images/close-pc.png"
        class="close"
        @click="closeModal"
      />
    </div>
  </div>
</template>

<script>
import util from "../../assets/js/util";
import { getAreaList, traceKyc } from "@/api/api";

export default {
  data() {
    return {
      isMobile: util.device.isMobile,
      products: [],
      money: "",
      age: "",
      province: {},
      city: "",
      assign: null,
      pro: [],
      service: 2,
      notice1: false,
      notice2: false,
      notice3: false,
      notice4: false,
      notice5: false,
      hasSubmited: false
    };
  },
  props: {
    moduleData: {
      type: Object
    },
    step: {
      type: Number
    },
    showModal: {
      type: Boolean
    },
    pageInfo: {
      type: Object
    },
    groupNo: {
      type: [String, Number]
    }
  },
  created() {
    getAreaList({ type: 1 }).then(res => {
      this.pro = res.data.data;
    });
    util.ui.createWait();
  },
  watch: {
    province: {
      handler(newVal, oldVal) {
        if (!oldVal.code || oldVal.code !== newVal.code) {
          this.city = "";
          if (this.hasSubmited) this.validate();
          if (newVal.ITEMS) return;
          util.ui.createWait();
          getAreaList({
            type: 2,
            parent_code: newVal.code
          })
            .then(res => {
              this.$set(
                this.pro.find(val => val.code == newVal.code),
                "ITEMS",
                res.data.data
              );
              if (this.province.ITEMS.length > 0) {
                this.city = this.province.ITEMS[0].name;
              }
            })
            .finally(() => {
              util.ui.closeWait();
            });
        }
      },
      deep: true
    },
    money() {
      if (this.hasSubmited) this.validate();
    },
    age() {
      if (this.hasSubmited) this.validate();
    },
    products() {
      if (this.hasSubmited) this.validate();
    },
    city() {
      if (this.hasSubmited) this.validate();
    },
    service() {
      if (this.hasSubmited) this.validate();
    }
  },
  methods: {
    submit() {
      console.log("submit");
      this.hasSubmited = true;
      if (!this.validate()) return;
      // const list = {type: null, kyc: {
      //   q1: this.products.join(' '),
      //   q2: this.money,
      //   q3: this.age,
      //   q4: this.province.name + "|" + this.city,
      //   q5: this.service
      // }}
      const list = [
        {
          quNo: 1,
          optionNo: this.products.join(",")
        },
        {
          quNo: 2,
          optionNo: this.money
        },
        {
          quNo: 3,
          optionNo: this.age
        },
        {
          quNo: 4,
          optionNo: this.province.name + "|" + this.city
        },
        {
          quNo: 5,
          optionNo: this.service
        }
      ];

      let sid = localStorage.getItem("sid");
      util
        .ajax({
          header: { "X-KGW-SID": sid },
          reqData: [
            {
              method: "active.customer_info_apply",
              params: {
                answerList: JSON.stringify(list),
                city: this.$route.query.city || ""
              }
            }
          ]
        })
        .then((err, resArr) => {
          let reserveId = localStorage.getItem("reserveId");
          traceKyc({
            reserveId: reserveId,
            kycData: JSON.stringify(list)
          });
          if (resArr[1].result && resArr[1].result.result == "1") {
            this.$emit("setStep", 3);
            /**
             * 调研成功埋点
             */
            this.$sensors.track('pptf_kyc_success', {
              ...this.pageInfo,
              customer_id: this.groupNo
            })
          } else {
            this.$toast.show(resArr[1].error.message);
            /**
             * 调研失败埋点
             */
            this.$sensors.track('pptf_kyc_failed', {
              ...this.pageInfo,
              customer_id: this.groupNo
            })
          }
        });
    },
    validate() {
      if (this.products.length == 0) {
        this.notice1 = true;
      } else {
        this.notice1 = false;
      }
      if (!this.money) {
        this.notice2 = true;
      } else {
        this.notice2 = false;
      }
      if (!this.age) {
        this.notice3 = true;
      } else {
        this.notice3 = false;
      }
      if (!this.city) {
        this.notice4 = true;
      } else {
        this.notice4 = false;
      }
      if (typeof this.service !== "number") {
        this.notice5 = true;
      } else {
        this.notice5 = false;
      }
      return (
        !this.notice1 &&
        !this.notice2 &&
        !this.notice3 &&
        !this.notice4 &&
        !this.notice5
      );
    },
    closeModal() {
      this.$emit("setStep", 3);
    }
  }
};
</script>

<style lang="less" scoped>
.questionnaire {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.mobile {
  .modal-box {
    width: 6.7rem;
    height: 10.3rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-bottom-left-radius: 0.2rem;
    border-bottom-right-radius: 0.2rem;
    -webkit-overflow-scrolling: touch;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 1rem,
      #ffffff 1rem,
      #ffffff 100%
    );

    .modal-box-header {
      width: 100%;
      // height: 3.27rem;
      position: relative;
      // background: linear-gradient(transparent 20%, #fff 20%) left top / cover no-repeat;

      .modal-box-image {
        width: 100%;
        height: 3.04rem;
      }

      .tips {
        width: 100%;
        height: 0.33rem;
        line-height: 0.33rem;
        font-size: 0.24rem;
        color: #c49368;
        padding-left: 0.48rem;
        margin-top: 0.1rem;
        box-sizing: border-box;
      }
    }

    .questions {
      width: 5.9rem;
      width: 100%;
      height: 5rem;
      margin: 0.2rem auto 0;
      padding: 0 0.4rem;
      overflow-y: auto;
      box-sizing: border-box;

      .question {
        .question-name {
          // width: 100%;
          // height: 0.45rem;
          // margin-bottom: 0.2rem;
          // display: flex;
          font-size: 0.28rem;
          text-align: justify;
          font-weight: 600;
          color: #c49368;

          i {
            font-weight: 0.38rem;
            margin-right: 0.1rem;
          }

          .notice {
            color: red;
          }

          // .question-num {
          //   width: 0.42rem;
          //   height: 0.42rem;
          //   margin-right: 0.1rem;
          // }

          // span {
          //   height: 0.45rem;
          //   line-height: 0.45rem;
          //   font-size: 0.32rem;
          //   font-weight: 600;
          //   color: #C49368;
          // }
        }

        .question-options {
          // width: 5.52rem;
          display: flex;
          flex-flow: row wrap;
          padding: 0.1rem 0;
          // margin-left: 0.5rem;
          margin-top: 0.2rem;
          margin-bottom: 0.1rem;
          box-sizing: border-box;

          .question-option {
            width: 50%;
            height: 0.42rem;
            font-size: 0.3rem;
            line-height: 0.42rem;
            color: #323232;
            margin-bottom: 0.3rem;
            position: relative;
            display: flex;
            align-items: center;

            label {
              height: 0.42rem;
              line-height: 0.42rem;
            }
          }

          .option-checkbox,
          .option-radio {
            appearance: none;
            -webkit-appearance: none;
            vertical-align: middle;
            color: #808080;
            outline: 0;
            width: 0.42rem;
            height: 0.42rem;
            margin-right: 0.2rem;
            // position: absolute;
            // top: .02rem;
          }

          .option-checkbox:checked::before,
          .option-radio:checked::before {
            display: block;
            width: 0.42rem;
            height: 0.42rem;
            content: "";
            color: #000;
            font-size: 0.24rem;
          }

          .option-checkbox {
            background: url("../../assets/images/checkbox-no.png") center /
              contain no-repeat;
          }

          .option-checkbox:checked::before {
            background: url("../../assets/images/checkbox-yes.png") center /
              contain no-repeat;
          }

          .option-radio {
            background: url("../../assets/images/radio-no.png") center / contain
              no-repeat;
          }

          .option-radio:checked::before {
            background: url("../../assets/images/radio-yes.png") center /
              contain no-repeat;
          }
        }

        .question-selector {
          width: 5.84rem;
          display: flex;
          justify-content: space-between;
          color: #323232;
          margin: 0.3rem auto 0.9rem;

          .question-select-wrapper {
            width: 2.6rem;
            height: 0.6rem;
            position: relative;
          }

          .question-select {
            width: 2.6rem;
            height: 0.6rem;
            padding: 0 0.2rem;
            box-sizing: border-box;
            appearance: none;
            border: 1px solid #d9d9d9;
            position: absolute;
            background-image: linear-gradient(#f6f5f4 50%, #f6f5f4 50%);
            background-size: 0.6rem 0.6rem;
            background-position: right top;
            background-repeat: no-repeat;
          }

          .question-select-wrapper:after {
            width: 0px;
            height: 0px;
            content: "";
            border-top: 0.1rem solid #969696;
            border-right: 0.1rem solid transparent;
            border-left: 0.1rem solid transparent;
            border-bottom: 0.1rem solid transparent;
            display: block;
            position: absolute;
            right: 0.2rem;
            top: 0.25rem;
            z-index: 1;
            pointer-events: none;
          }
        }
      }
    }

    .modal-box-footer {
      padding: 0 0.4rem;
      margin-bottom: 0.28rem;
      overflow: hidden;

      .modal-box-submit {
        width: 5.1rem;
        height: 0.8rem;
        line-height: 0.8rem;
        margin: 0.2rem auto;
        background: linear-gradient(315deg, #c49368 0%, #e3bb98 100%);
        box-shadow: 0px 0.04rem 0.08rem 0px rgba(227, 187, 152, 0.4);
        border-radius: 0.4rem;
        font-size: 0.32rem;
        color: #fff;
        text-align: center;
        // opacity: 0.3;
      }
    }

    .close {
      width: 0.48rem;
      height: 0.48rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -0.74rem;
    }
  }
}
.pc {
  .modal-box {
    width: 5.06rem;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 1rem,
      #ffffff 1rem,
      #ffffff 100%
    );
    border-bottom-left-radius: 0.06rem;
    border-bottom-right-radius: 0.06rem;
    box-sizing: border-box;

    .modal-box-header {
      width: 100%;
      position: relative;

      .modal-box-image {
        width: 100%;
        height: 2.3rem;
      }

      .tips {
        width: 100%;
        height: 0.24rem;
        line-height: 0.24rem;
        font-size: 0.17rem;
        color: #c49368;
        padding-left: 0.28rem;
        box-sizing: border-box;
        margin-top: 0.14rem;
      }
    }

    .questions-wrapper {
      width: calc(100% - 17px);
      height: 4.22rem;
      display: block;
      overflow: hidden;
      margin: 0.281rem auto 0;
    }

    .questions {
      margin: 0.281rem auto 0;
      width: 4.5rem;
      height: 4.22rem;
      // padding: 0 0.23rem;
      box-sizing: border-box;
      overflow-y: auto;

      .question {
        .question-name {
          font-size: 0.197rem;
          text-align: justify;
          font-weight: 600;
          color: #c49368;

          i {
            font-size: 0.281rem;
            margin-right: 0.141rem;
          }

          .notice {
            color: red;
          }
        }

        .question-options {
          display: flex;
          flex-flow: row wrap;
          padding: 0 0.394rem;
          margin-top: 0.281rem;
          margin-bottom: 0.141rem;
          box-sizing: border-box;
          align-items: center;

          .question-option {
            width: 50%;
            height: 0.239rem;
            font-size: 0.169rem;
            line-height: 0.239rem;
            color: #323232;
            margin-bottom: 0.281rem;
            position: relative;

            label {
              position: absolute;
              left: 0.337rem;
            }
          }

          .option-checkbox,
          .option-radio {
            appearance: none;
            -webkit-appearance: none;
            vertical-align: middle;
            color: #808080;
            line-height: 1;
            outline: 0;
            width: 0.197rem;
            height: 0.197rem;
            position: absolute;
            top: 0.028rem;
          }

          .option-checkbox:checked::before,
          .option-radio:checked::before {
            display: block;
            width: 0.197rem;
            height: 0.197rem;
            content: "";
            color: #000;
            font-size: 0.169rem;
          }

          .option-checkbox {
            background: url("../../assets/images/checkbox-no.png") center /
              contain no-repeat;
          }

          .option-checkbox:checked::before {
            background: url("../../assets/images/checkbox-yes.png") center /
              contain no-repeat;
          }

          .option-radio {
            background: url("../../assets/images/radio-no.png") center / contain
              no-repeat;
          }

          .option-radio:checked::before {
            background: url("../../assets/images/radio-yes.png") center /
              contain no-repeat;
          }
        }

        .question-selector {
          width: 98%;
          display: flex;
          justify-content: space-between;
          color: #323232;
          // margin-left: 0.2rem;
          margin: 0.281rem 0 0.2rem;

          .question-select-wrapper {
            width: 2rem;
            height: 0.56rem;
            position: relative;
          }

          .question-select {
            width: 2rem;
            height: 0.56rem;
            padding: 0 0.62rem 0 0.22rem;
            box-sizing: border-box;
            appearance: none;
            border: 1px solid #d9d9d9;
            position: absolute;
            background-image: linear-gradient(#f6f5f4 50%, #f6f5f4 50%);
            background-size: 0.56rem 0.56rem;
            background-position: right top;
            background-repeat: no-repeat;
          }

          .question-select-wrapper:after {
            width: 0px;
            height: 0px;
            content: "";
            border-top: 0.1rem solid #969696;
            border-right: 0.1rem solid transparent;
            border-left: 0.1rem solid transparent;
            border-bottom: 0.1rem solid transparent;
            display: block;
            position: absolute;
            right: 0.2rem;
            top: 0.25rem;
            z-index: 1;
            pointer-events: none;
          }
        }
      }
    }

    .questions::-webkit-scrollbar {
      width: 8px;
      background-color: #cccccc;
    }

    .questions::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(214, 168, 127, 0.4);
      background-color: #d8ab84;
    }

    .modal-box-footer {
      overflow: hidden;

      .modal-box-submit {
        width: 1.9rem;
        height: 0.56rem;
        line-height: 0.56rem;
        margin: 0.422rem auto;
        background: linear-gradient(315deg, #c49368 0%, #e3bb98 100%);
        border-radius: 0.28rem;
        font-size: 0.197rem;
        color: #fff;
        text-align: center;
        cursor: pointer;
        // opacity: 0.3;
      }
    }

    .close {
      width: 0.27rem;
      height: 0.27rem;
      position: absolute;
      top: 0.45rem;
      right: 0.14rem;
      cursor: pointer;
    }
  }

  // .modal-box::-webkit-scrollbar {
  //   width: 0px;
  //   height: 0px;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/questionnaire.vue